import { render } from "./modal-box.component.html?vue&type=template&id=2b97f15a&ts=true&external"
import script from "./modal-box.component.ts?vue&type=script&lang=ts&external"
export * from "./modal-box.component.ts?vue&type=script&lang=ts&external"

import "./modal-box.component.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__